import axios from "axios";
import { siteSettings } from "../static";

export async function uploadImageToCloudinary(file, onUploadProgress) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", siteSettings.uploadPreset);

  const config = {};
  if (onUploadProgress) {
    config.onUploadProgress = (progressEvent) => {
      const progress = (progressEvent.loaded / progressEvent.total) * 100;
      onUploadProgress(Number(progress));
    };
  }

  const response = await axios.post(
    `https://api.cloudinary.com/v1_1/${siteSettings.cloudName}/image/upload`,
    formData,
    config
  );

  return response.data.secure_url;
}
